var breakpoint = function (width) { return "@media (min-width: ".concat(width, "px)"); };
var theme = {
    breakpoints: {
        md: breakpoint(600),
        lg: breakpoint(1024),
    },
    colors: {
        ensoBlue: '#A2D3E8',
        helsinkiBlue: '#2F4A73',
        helsinkiBlueDark: '#101926',
        lightGray: '#E5E7EB',
        white: '#FFF',
    },
    fontFamily: {
        sans: 'AkkuratLL, ui-sans-serif, sans-serif',
    },
};
export default theme;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGhlbWUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29uc3RzL3RoZW1lLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQU0sVUFBVSxHQUFHLFVBQUMsS0FBYSxJQUFhLE9BQUEsNkJBQXNCLEtBQUssUUFBSyxFQUFoQyxDQUFnQyxDQUFDO0FBRS9FLElBQU0sS0FBSyxHQUFHO0lBQ1osV0FBVyxFQUFFO1FBQ1gsRUFBRSxFQUFFLFVBQVUsQ0FBQyxHQUFHLENBQUM7UUFDbkIsRUFBRSxFQUFFLFVBQVUsQ0FBQyxJQUFJLENBQUM7S0FDckI7SUFDRCxNQUFNLEVBQUU7UUFDTixRQUFRLEVBQUUsU0FBUztRQUNuQixZQUFZLEVBQUUsU0FBUztRQUN2QixnQkFBZ0IsRUFBRSxTQUFTO1FBQzNCLFNBQVMsRUFBRSxTQUFTO1FBQ3BCLEtBQUssRUFBRSxNQUFNO0tBQ2Q7SUFDRCxVQUFVLEVBQUU7UUFDVixJQUFJLEVBQUUsc0NBQXNDO0tBQzdDO0NBQ0YsQ0FBQztBQUVGLGVBQWUsS0FBSyxDQUFDIn0=